// In development we'll show all non-hidden models in the catalog
// with these availability indicators.

import {Pill} from '@wandb/components';
import React from 'react';

import {Model} from './types';

type AvailableInProps = {
  model: Model;
};

export const AvailableIn = ({model}: AvailableInProps) => {
  const {availableIn} = model;
  const isInProd = availableIn.includes('cw-prod');
  const isInQa = availableIn.includes('cw-qa');
  return (
    <div className="flex gap-4">
      {isInQa && <Pill textValue="QA" color="cactus" />}
      {isInProd && <Pill textValue="Prod" color="green" />}
    </div>
  );
};
